export default __webpack_public_path__ + "static/media/add-row.4bef47ab.svg";